export default __webpack_public_path__ + "static/media/ic_gmx_avax.c79d2528.svg";